import {ChargeComponent} from '@/dto/subscription/SublimeChargeDTO';
import {SublimeCompanyType} from '@/dto/SublimeCompanyType';

/**
 * Defines which components belong to which Sublime issuer (company).
 * Extend this mapping as new components appear on the backend (e.g., POSTAL_REGISTER_MONTHLY_FEE -> SUBLIME_CONSULTING).
 */
const COMPONENT_ISSUER_MAP: Record<ChargeComponent, SublimeCompanyType> = {
    [ChargeComponent.PAYROLL_MONTHLY_FEE]: SublimeCompanyType.SUBLIME_PAYROLL_SERVICES,
    [ChargeComponent.PAYROLL_QUARTERLY_FEE]: SublimeCompanyType.SUBLIME_PAYROLL_SERVICES,
    [ChargeComponent.PAYSTUB]: SublimeCompanyType.SUBLIME_PAYROLL_SERVICES,
    [ChargeComponent.QUARTER_REPORT]: SublimeCompanyType.SUBLIME_PAYROLL_SERVICES,
    [ChargeComponent.TIMESHEET]: SublimeCompanyType.SUBLIME_CONSULTING,
    [ChargeComponent.POSTAL_REGISTER_MONTHLY_FEE]: SublimeCompanyType.SUBLIME_CONSULTING,
    [ChargeComponent.INVOICES]: SublimeCompanyType.SUBLIME_CONSULTING,
    [ChargeComponent.SUBLIME_DOCS]: SublimeCompanyType.SUBLIME_CONSULTING,
};

/**
 * Returns true if the given component is allowed for the issuer.
 */
export function isComponentAllowedForIssuer(component: ChargeComponent | null | undefined, issuer: SublimeCompanyType | null | undefined): boolean {
  if (!component || !issuer) return false;
  const mapped = COMPONENT_ISSUER_MAP[component as ChargeComponent];
  return mapped === issuer;
}

/**
 * Returns a Set of components allowed for the given issuer.
 */
export function componentsAllowedForIssuer(issuer: SublimeCompanyType | null | undefined): Set<ChargeComponent> {
  const set = new Set<ChargeComponent>();
  if (!issuer) return set;
  (Object.keys(COMPONENT_ISSUER_MAP) as Array<keyof typeof COMPONENT_ISSUER_MAP>).forEach((k) => {
    if (COMPONENT_ISSUER_MAP[k] === issuer) set.add(k as ChargeComponent);
  });
  return set;
}
